import { SellOrderLogModelType } from '@teinor/erp/types/company/order/sell/sellOrder/sellOrderLog'
import { Fragment } from 'react'
import { InputTableLayoutData } from '../../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import OrderStatusBar from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderStatusBar'
import { getOrderStatusBarType } from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderStatusBar/functions'
import { displayDate } from '../../../../../../../../../utils/globals/date'
import { TwinDictionary } from '../../../../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { sellOrderStatusInversed } from '@teinor/erp/types/company/order/sell/sellOrder'
import OrderStatusBarDropDown from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderStatusBarDropDown'
import { faClock, faPenCircle } from '@fortawesome/pro-light-svg-icons'
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons'


export interface SellOrderStatusBarProps extends CreateStatusBarProps { }

const SellOrderStatusBar: React.FC<SellOrderStatusBarProps> = ({ completeData}) => {
    const { statuses } = useCreateStatusBar({ completeData })
    return (
        <OrderStatusBar statuses={statuses} currentOrderStatus={completeData?.header.status} getOrderStatusBarType={getOrderStatusBarType} />
    )
}

interface CreateStatusBarProps {
    completeData: InputTableLayoutData | null
}

const useCreateStatusBar = ({ completeData }: CreateStatusBarProps) => {
    const { t } = useTwinTranslation()
    const sellOrderStatus = completeData?.header.status
    const OrderLogs = completeData?.header?.OrderLogs
    const QuoteOrderId = completeData?.header?.QuoteOrderId
    let statuses: TwinDictionary[] = []
    const dictOrderLogs: TwinDictionary = {}
    for (const log of OrderLogs) {
        if (!dictOrderLogs[log.logType]) {
            dictOrderLogs[log.logType] = [log]
        } else {
            dictOrderLogs[log.logType] = [...dictOrderLogs[log.logType], log]
        }
    }
    if (QuoteOrderId) {
        statuses.push({
            id: -1,
            name: t('quoteOrder', 'Presupuesto'),
            logType: 0,
            color: 'bg-gray-33',
            icon: faPenCircle,
            className: 'text-gray-33',
            extraClassName: 'border border-gray-33',
            renderMessage: dictOrderLogs[0]?.length ? <RenderLogMessage logs={dictOrderLogs[0] || []} QuoteOrderId={QuoteOrderId} /> : null
        })
    } 
    statuses.push({
        id: 0,
        name: t('draft', 'Borrador'),
        logType: 0,
        color: 'bg-gray-33',
        icon: faPenCircle,
        className: 'text-gray-33',
        extraClassName: 'border border-gray-33',
        renderMessage: dictOrderLogs[0]?.length ? <RenderLogMessage logs={dictOrderLogs[0] || []} /> : null
    })
    statuses.push(
        {
            id: sellOrderStatus === sellOrderStatusInversed['pendingUnits'] ? 2 : 1,
            name: t('preparing', 'Preparando'),
            logType: 1,
            color: 'bg-orange-DE',
            icon: faClock,
            className: 'text-orange-DE',
            extraClassName: 'border border-orange-DE',
            renderMessage: dictOrderLogs[1]?.length ? <RenderLogMessage logs={dictOrderLogs[1] || []} /> : null
        }
    )
    statuses.push({
        id: 3,
        name: t('finalized', 'Finalizado'),
        logType: 2,
        color: 'bg-green-43',
        icon: faCheckCircle,
        className: 'text-green-43',
        renderMessage: dictOrderLogs[2]?.length ? <RenderLogMessage logs={dictOrderLogs[2] || []} /> : null
    })

    return { statuses, sellOrderStatus }
}

interface RenderLogMessageProps {
    logs: SellOrderLogModelType[]
    QuoteOrderId?: number
}

const RenderLogMessage: React.FC<RenderLogMessageProps> = ({ logs, QuoteOrderId }) => {
    const { tVars } = useTwinTranslation()
    const renderMessage: JSX.Element[] = []
    for (const log of logs) {
        const myExtraData = log?.extraData ? JSON.parse(log?.extraData) : null
        const options = { employeeTrigger: log.EmployeeTrigger?.fullname_short || '', date: displayDate(new Date(log.createdAt)), full_assigned_number: myExtraData?.full_assigned_number || null, 'interpolation': { 'escapeValue': false }}
        const dictSellOrderLogsMessages: TwinDictionary = {
            0: tVars('createdSellOrderLogMessage', '{{employeeTrigger}} creó el pedido el {{date}}', options),
            1: tVars('processingSellOrderLogMessage', '{{employeeTrigger}} marcó el pedido como procesando el {{date}}', options),
            2: tVars('finalizedSellOrderLogMessage', '{{employeeTrigger}} marcó el pedido como finalizado el {{date}}', options),
            3: tVars('createdOrderByQuoteLogMessage', '{{employeeTrigger}} creó el pedido a partir del presupuesto {{full_assigned_number}}', options),
        }
        let myLogType: number = log.logType
        if (log.logType === 0 && QuoteOrderId) {
            myLogType = 3
        }
        if (dictSellOrderLogsMessages[log.logType]) {
            renderMessage.push(<div className='my-5' key={log.id} > {dictSellOrderLogsMessages[myLogType]} </div>)
        }
    }
    if (!renderMessage.length) {
        return null
    }
    return (<Fragment>{renderMessage}</Fragment>)
}

export const SellOrderStatusBarNew: React.FC<SellOrderStatusBarProps> = ({ completeData }) => {
    const { statuses, sellOrderStatus } = useCreateStatusBar({ completeData })
    return (
        <OrderStatusBarDropDown statuses={statuses} currentOrderStatus={sellOrderStatus} getOrderStatusBarType={getOrderStatusBarType} isAccepted={sellOrderStatus === sellOrderStatusInversed['accepted']} />
    )
}

export default SellOrderStatusBar